import { CountryVO } from '../../vo/locale/country.vo';
import { LanguageVO } from '../../vo/locale/language.vo';
import { BusinessUnitVO } from '../../vo/core/business-unit.vo';
import { BASIC_ENTITY_TYPE } from '../../model/enums';
import { ChronocodeVO, FreeDataVO, FreedataValueVO, IVo, WorkComVO } from '@wizeoo/akm-compute-lib';


/** Récupération d'un EntityClass à partir du VO */
export function getEntityClassFromVO(pVo: IVo): number {
  switch (pVo.constructor.name) {
    case FreeDataVO.name:
      return BASIC_ENTITY_TYPE.FREEDATA;
    case ChronocodeVO.name:
      return BASIC_ENTITY_TYPE.CHRONOCODE;
    case BusinessUnitVO.name:
      return BASIC_ENTITY_TYPE.BUSINESS_UNIT;
    case LanguageVO.name:
      return BASIC_ENTITY_TYPE.LANGUAGE;
    case CountryVO.name:
      return BASIC_ENTITY_TYPE.COUNTRY;
    case FreedataValueVO.name:
      return BASIC_ENTITY_TYPE.FREEDATAVALUE;
    case WorkComVO.name:
      return BASIC_ENTITY_TYPE.WORKCOM;
    default:
      return null; // -1;
  }
}
